export default "__VITE_ASSET__CgZIzxZ___"